import { render, staticRenderFns } from "./DuplicatedLeadBanner.vue?vue&type=template&id=732acb52&lang=true"
import script from "./DuplicatedLeadBanner.vue?vue&type=script&lang=js"
export * from "./DuplicatedLeadBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports